import {
  useEffect,
} from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import {
  api,
  clearPosSession,
  getPosSession,
} from "./api";


export default function POSSessionMonitor() {
  const { company } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!company) return undefined;

    let stopped = false;
    let checking = false;
    let activeController = null;

    async function checkSession() {
      if (
        stopped ||
        checking ||
        document.visibilityState === "hidden"
      ) {
        return;
      }

      const session = getPosSession(company);
      const token = session?.access_token;

      if (!token) return;

      checking = true;

      const controller = new AbortController();
      activeController = controller;

      const timeout = window.setTimeout(
        () => controller.abort(),
        8000
      );

      try {
        await api.get(
          "/auth/pos/me",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            signal: controller.signal,
          }
        );
      } catch (requestError) {
        if (
          stopped ||
          controller.signal.aborted
        ) {
          return;
        }

        // Una respuesta de un token anterior no debe
        // borrar uno renovado al actualizar el perfil.
        const currentToken =
          getPosSession(company)?.access_token;

        if (
          requestError.response?.status === 401 &&
          currentToken === token
        ) {
          clearPosSession(company, token);

          navigate(
            `/${encodeURIComponent(company)}?session=expired`,
            {
              replace: true,
            }
          );
        }

        // Los errores de red no cierran la sesión.
      } finally {
        window.clearTimeout(timeout);
        checking = false;

        if (activeController === controller) {
          activeController = null;
        }
      }
    }

    function handleVisibility() {
      if (document.visibilityState === "visible") {
        checkSession();
      }
    }

    checkSession();

    const interval = window.setInterval(
      checkSession,
      15000
    );

    window.addEventListener("focus", checkSession);

    document.addEventListener(
      "visibilitychange",
      handleVisibility
    );

    return () => {
      stopped = true;

      window.clearInterval(interval);
      activeController?.abort();

      window.removeEventListener(
        "focus",
        checkSession
      );

      document.removeEventListener(
        "visibilitychange",
        handleVisibility
      );
    };
  }, [company, navigate]);

  return null;
}